import { RootState } from '../store';

export const getUserBrands = (state: RootState) => state.brand.userBrands;
export const getActiveBrand = (state: RootState) => state.brand.activeBrand;
export const getActiveBrandOnBoardedStatus = (state: RootState) =>
    state.brand.activeBrand ? state.brand.activeBrand.onBoardedStatus : false;
